export const RETRIEVE_SELECTED_CHART_DETAILS_BEGIN = 'RETRIEVE_SELECTED_CHART_DETAILS_BEGIN';
export const RETRIEVE_SELECTED_CHART_DETAILS_SUCCESS = 'RETRIEVE_SELECTED_CHART_DETAILS_SUCCESS';
export const RETRIEVE_SELECTED_CHART_DETAILS_FAILURE = 'RETRIEVE_SELECTED_CHART_DETAILS_FAILURE';
export const UPDATE_SELECTED_CHART_DETAILS_AFTER_SARCASM_TOGGLED = 'UPDATE_SELECTED_CHART_DETAILS_AFTER_SARCASM_TOGGLED';
export const UPDATE_SELECTED_CHART_DETAILS_AFTER_COMMENT_OR_TWEET_RELEVANCE_UPDATES = 'UPDATE_SELECTED_CHART_DETAILS_AFTER_COMMENT_OR_TWEET_RELEVANCE_UPDATES';
export const UPDATE_SELECTED_CHART_DETAILS_AFTER_POST_RELEVANCE_UPDATES = 'UPDATE_SELECTED_CHART_DETAILS_AFTER_POST_RELEVANCE_UPDATES';
export const CHART_REFLOW_FIRST_WAIT_TIME_IN_MILLISECONDS  = 500;
export const CHART_REFLOW_SECOND_WAIT_TIME_IN_MILLISECONDS = 3500;
export const RETREIVE_ALL_LABELS_BEGIN = "RETREIVE_ALL_LABELS_BEGIN";
export const RETREIVE_ALL_LABELS_SUCCESS = "RETREIVE_ALL_LABELS_SUCCESS";
export const RETREIVE_ALL_LABELS_FAILURE = "RETREIVE_ALL_LABELS_FAILURE";
export const CREATE_EVENT_LABEL_SUCCESS = "CREATE_EVENT_LABEL_SUCCESS";
export const EDIT_EVENT_LABEL_SUCCESS = "EDIT_EVENT_LABEL_SUCCESS";
export const DELETE_EVENT_LABEL_SUCCESS = "DELETE_EVENT_LABEL_SUCCESS";

export const EMOTION_OR_SENTIMENT_MENTIONS_CHARTS_IDS = [
    "chart100",
    "chart101"
];
export const SENTIMENT_TREND_CHART_ID = "chart102";
export const EMOTION_TREND_CHART_ID = "chart103";
export const SENTIMENT_PERCENTAGE_TREND_CHART_ID = "chart124";
export const EMOTION_PERCENTAGE_TREND_CHART_ID = "chart125";
export const EMOTION_OR_SENTIMENT_TREND_CHART_IDS = [
    SENTIMENT_TREND_CHART_ID,
    EMOTION_TREND_CHART_ID
];
export const EMOTION_OR_SENTIMENT_PERCENTAGE_TREND_CHART_IDS = [
    SENTIMENT_PERCENTAGE_TREND_CHART_ID,
    EMOTION_PERCENTAGE_TREND_CHART_ID
];
export const EMOTION_PIE_CHART_ID = "chart105";
export const EMOTION_OR_THREE_CLASS_SENTIMENT_PIE_CHARTS_IDS =  [
    "chart104",
    EMOTION_PIE_CHART_ID
];
export const EMOTION_OR_SENTIMENT_SPIDER_CHART_IDS = [
    "chart106"
];
export const FIVE_CLASS_SENTIMENT_PIE_CHARTS_IDS = [
    "chart107"
];
export const EMOTION_OR_SENTIMENT_BAR_CHART_IDS = [
    "chart108"
];
export const AVAILABLE_SOURCES_PIE_CHART_IDS = [
    "chart109"
];
export const SUB_TOPIC_CLUSTERS_CHART_IDS = [
    "chart126"
];
export const CHARTS_WHICH_NEED_ADJUSTMENT_FOR_SARCASM = [].concat(
    EMOTION_OR_SENTIMENT_MENTIONS_CHARTS_IDS,
    EMOTION_OR_SENTIMENT_TREND_CHART_IDS,
    EMOTION_OR_THREE_CLASS_SENTIMENT_PIE_CHARTS_IDS,
    FIVE_CLASS_SENTIMENT_PIE_CHARTS_IDS,
    EMOTION_OR_SENTIMENT_BAR_CHART_IDS,
    EMOTION_OR_SENTIMENT_PERCENTAGE_TREND_CHART_IDS,
    SUB_TOPIC_CLUSTERS_CHART_IDS
);
export const CHARTS_WHICH_NEED_ADJUSTMENT_FOR_RELEVANCE = [].concat(
    EMOTION_OR_SENTIMENT_MENTIONS_CHARTS_IDS,
    EMOTION_OR_SENTIMENT_TREND_CHART_IDS,
    EMOTION_OR_THREE_CLASS_SENTIMENT_PIE_CHARTS_IDS,
    FIVE_CLASS_SENTIMENT_PIE_CHARTS_IDS,
    EMOTION_OR_SENTIMENT_BAR_CHART_IDS,
    AVAILABLE_SOURCES_PIE_CHART_IDS,
    EMOTION_OR_SENTIMENT_PERCENTAGE_TREND_CHART_IDS,
    SUB_TOPIC_CLUSTERS_CHART_IDS
);

export const SENTIMENT_TREND_CHART_ID_VALUE = "102";
export const EMOTION_TREND_CHART_ID_VALUE = "103";
export const SENTIMENT_PERCENTAGE_TREND_CHART_ID_VALUE = "124";
export const EMOTION_PERCENTAGE_TREND_CHART_ID_VALUE = "125";

export const EMOTION_OR_SENTIMENT_TREND_CHART_ID_VALUES = [
    SENTIMENT_TREND_CHART_ID_VALUE,
    EMOTION_TREND_CHART_ID_VALUE,
    SENTIMENT_PERCENTAGE_TREND_CHART_ID_VALUE,
    EMOTION_PERCENTAGE_TREND_CHART_ID_VALUE
];

export const POSITIVE_MENTIONS = "positive mentions";
export const NEGATIVE_MENTIONS = "negative mentions";

export const MENTIONS_LABEL = " mentions";
export const PARSE_INT_RADIX = 10;
export const KEY_FOR_CHART_ID = "chartId";
export const KEY_FOR_LABEL_DATE_TIME = "labelDateTime";
export const KEY_FOR_LABEL_TEXT = "labelText";
export const KEY_FOR_USER_EMAIL = "userEmail";
export const KEY_FOR_TOPIC_ID = "topicId";
export const KEY_FOR_EVENT_LABEL_ID = "id";
export const TOTAL = "total";

export const MONTH_UNIT = "month";
export const DAY_UNIT = "day";
export const HOUR_UNIT = "hour";

export const MAXIMUM_NUMBER_OF_DAYS_FOR_DAILY_TREND_CHARTS = 180;
export const DEFAULT_DAY_FOR_MONTHLY_TREND_CHARTS = "1";
export const DEFAULT_HOUR_FOR_DAILY_AND_MONTHLY_TREND_CHARTS = "0"; 



// WEBPACK FOOTER //
// ./src/features/shared-components/chart/redux/constants.js